// extracted by mini-css-extract-plugin
export default {"pageContent":"page_pageContent__g0mLI","elements":"page_elements__kDCRI"};